module.exports = __webpack_public_path__ + "static/img/upload-bg.5218016.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/upload-bg.png
// module id = 4TQe
// module chunks = 1